import React from 'react';
import './gigItem.css';

const GigItem = ({ gig, removeGig }) => (
    <div className="gigItem">
        <div className="gigItem__name">
            {gig.name}
        </div>
        <div className="gigItem__location">
            {gig.location}
        </div>
        <div className="gigItem__date">
            {gig.date}
        </div>
        <div className="gigItem__date">
            {gig.note}
        </div>
        <div className="gigItem__removeButton" onClick={() => removeGig(gig.id)}>
           X
        </div>
    </div>
);

export default GigItem;